import { useMemo } from 'react';

import { useGetCapitalProvidersQuery } from 'packages/organization/requests/organization.gql.generated';

export const useGetCapitalProviderOptions = (creditFacilityId: string) => {
  const { data: capitalProvidersData, error } = useGetCapitalProvidersQuery({
    variables: { creditFacilityId },
  });

  const capitalProviderOptions = useMemo(() => {
    return (
      capitalProvidersData?.capitalProviders.map((capitalProvider) => ({
        label: capitalProvider.name,
        value: capitalProvider.id,
      })) ?? []
    );
  }, [capitalProvidersData]);

  if (error) throw error;

  return capitalProviderOptions;
};
